
import Vue from 'vue'
import {router, combineRouter} from '@/router/game'
import store from '@/store/store'
import axios from '@/utils/axios'
import service from '@/utils/service.js'
import _ from 'lodash'
//import Antd from 'ant-design-vue'
//import 'ant-design-vue/dist/antd.css'
import { Layout, Button, Icon, Spin, LocaleProvider, Row, Col, message, Input, InputNumber, Popconfirm, Drawer, Form, Rate, Modal, Upload, Empty, Tabs, Table, List, Pagination, Tooltip } from 'ant-design-vue';
import Common from '../views/common.vue'
import '@/assets/less/common.less'
import storage from '@/utils/storage'
import i18n from '@/locale/game'
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale(i18n && i18n.locale === 'en_US' ? 'en' : 'zh-cn');

Vue.use(Layout)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Spin)
Vue.use(LocaleProvider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Popconfirm)
Vue.use(Drawer)
Vue.use(Form)
Vue.use(Rate)
Vue.use(Modal)
Vue.use(Upload)
Vue.use(Empty)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(List)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(message)
Vue.use(_)

// 消息提醒
message.config({
  duration: 2,
  maxCount: 1,
});

//Vue.use(Antd);
Vue.config.productionTip = false

Vue.prototype.$_ = _
Vue.prototype.$message = message
Vue.prototype.$service = service
// 处理锚点
Vue.prototype.handleAnchor = (e, link) => {
    e.preventDefault();
    if(typeof(link)=='string' && link.split('#').length>=2) {
      var div = document.getElementById(link.split('#')[1]);
      div.scrollTop = div.scrollHeight;
    }
    return
}
Vue.filter('format', (value, decimal) => {
  if(_.isNil(value)) {
    return '/'
  }
  if(!isNaN(value)) {
    if(decimal>=0) {
      return Number(value).toFixed(decimal)
    }
    else {
      return Math.round(value).toLocaleString()
    }
  }
  else
      return value
})

Vue.filter('format_fixed', (value) => {
  if(_.isNil(value)) {
    return '计算中'
  }
  if(!isNaN(value))
      return Math.round(value).toLocaleString()
  else
      return value
})

const resolution = async function() {
  if(!store.state.user.email) {
    await store.dispatch('get_user')
  }
  if(store.state.user.email) {
    let data = {
      "mail": store.state.user.email,
      "width": window.screen.width,
      "height": window.screen.height,
    }
    axios.post('https://qa.leihuo.netease.com:19714/api/web_count/resolution/add', data).then(res => {
      console.log(res)
    }).catch(err => {
      console.log(err)
    })
  }
}
// resolution()

const initGame = () => {
  // 如果是错误页面
  if(['403', '404', '500'].indexOf(service.PAGE_NAME) >= 0) {
    new Vue({
      el:'#app',
      router,
      store,
      i18n,
      render: h => h(Common)
    })
  }
  else {
    // 有项目代号
    if(service.PROJ_CODE){
      store.commit('set_code', service.PROJ_CODE)
      store.dispatch('init_remember')
      store.dispatch('new_init_game').then((data) => {
        combineRouter(store.state.game.modules, store.state.game.info.name, (router)=>{
          // 本地记录上一次访问的代号
          storage.local.set('last_game', service.PROJ_CODE)
          new Vue({
            el:'#app',
            router,
            store,
            i18n,
            render: h => h(Common)
          })
        })
      }).catch((data)=>{
        if(data && data.status_code===403 && data.detail == '未登录, 请登录后访问') {
          return 
        }
        new Vue({
          el:'#app',
          router,
          store,
          i18n,
          render: h => h(Common)
        })
        router.replace({name: `${[404,403].indexOf(data.status_code)>=0? data.status_code: 500}`})
      })
    }
    // 无项目代号
    else {
      new Vue({
        el:'#app',
        router,
        store,
        i18n,
        render: h => h(Common)
      })
      router.replace({name:'404'})
    }
  }
}

initGame()
